import { PraRemarksItemsModels } from './pra-remarks-items.models';
import { PraRemarksResponsesModels } from './pra-remarks-responses.models';

export class PraRemarksModels {
  alternativeArvFiles?: any[];
  authorEdrpou?: string;
  authorEmail?: string;
  authorFullName?: string;
  authorPosition?: string;
  authorTitle?: string;
  createdAt?: string;
  items?: PraRemarksItemsModels[];
  regActProjectId?: string;
  regActRemarkId?: string;
  responses?: PraRemarksResponsesModels[];
  updatedAt?: string;
  userId?: string;


  constructor(item: any) {
    this.authorEdrpou = item.authorEdrpou;
    this.authorEmail = item.authorEmail;
    this.authorFullName = item.authorFullName;
    this.authorPosition = item.authorPosition;
    this.authorTitle = item.authorTitle;
    this.createdAt = item.createdAt;
    this.regActProjectId = item.regActProjectId;
    this.regActRemarkId = item.regActRemarkId;
    this.updatedAt = item.updatedAt;
    this.userId = item.userId;
    this.responses = item.responses?.map(
      (items: any) => new PraRemarksResponsesModels(items) || [],
    );
    this.items = item.items?.map(
      (items: any) => new PraRemarksItemsModels(items) || [],
    );
  }
}
